<template lang="pug">
  .table-4d.table-vg.hx-table.hx-top-rounded.hx-mt-2.live
    .hx-cell.flex-fill
      .hx-row.h-100
        .d-flex.flex-row.align-items-center.h-100
          .pl-1
            img(:src="'/images/icon-sport-svg/' + getImage(source.sportsId)" width="22")
          .d-flex.flex-row.align-items-baseline.align-item-margin
            .hx-header-title.live {{ source.marketType }}
            .hx-header-subtitle {{ source.sportsType }}
    .hx-cell.w-328
      .hx-row
        .hx-col.b-0.w-328
          .hx.text-center {{ $t("ui.full_time") }}
      .hx-row
        .hx-col.w-66
          .hx.text-center {{ $t("ui.ml") }}
        .hx-col.w-98
          .hx.text-center {{ $t("ui.hdp") }}
        .hx-col.w-98
          .hx.text-center {{ $t("ui.ou") }}
        .hx-col.w-66
          .hx.text-center(v-if="source.sportsId == 42") {{ $t("ui.ko") }}
          .hx.text-center(v-else) {{ $t("ui.oe") }}
    .hx-cell.w-40
      .hx-row.h-100
        .d-flex.flex-row.align-items-center.h-100.w-100
          .nav-item.nav-button.ml-auto
            a.nav-link(
              :href="'/efresult?q=' + source.sportsId + '&n=' + encodeURI(source.sportsType.replace('+', '$')) "
              target="_blank"
              onclick="event.stopPropagation();window.open(this.href,'efresult','top=10,height=400,width=950,status=no,toolbar=no,menubar=no,location=no');return false;"
            )
              i.fas.fa-chart-bar
</template>

<script>
import config from "@/config";
export default {
  props: {
    source: {
      type: Object
    },
  },
  methods: {
    getImage(e) {
      return config.getSportsImage(e);
    }
  }
}
</script>